import { Stack } from 'expo-router'

export const unstable_settings = {
  // Ensure that reloading on `/modal` keeps a back button present.
  initialRouteName: 'index',
}

export default function MediaSourceLayout() {
  return (
    <Stack>
      <Stack.Screen name="index" options={{ title: 'Media Source' }} />
      <Stack.Screen name="community" options={{ title: 'Chatta Community Image Search' }} />
      <Stack.Screen name="internet" options={{ title: 'Internet Image Search' }} />
    </Stack>
  )
}
